import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      studio: "Studio",
      dashboard: "Production Dashboard",
      credits: "Credits",
      logout: "Logout",
      new_project: "NEW PROJECT",
      back: "GO BACK",
      new_production: "New AI Production",
      pricing: "Processing fee: ",
      one_credit_per_min: "1 Credit per minute",
      of_video: "of video.",
      click_to_select: "Click to select a video",
      formats: "MP4, MOV formats, etc.",
      start_analysis: "START AI ANALYSIS",
      choose_another: "Choose another file",
      processing_warning: "Our AI engine is processing your video. Do not close this page.",
      retry: "Retry",
      syncing: "Synchronizing your projects...",
      empty_space: "Your workspace is empty",
      ready_to_transform: "Ready to turn your long videos into viral clips? You have",
      credits_to_start: "credits to get started!",
      create_first: "CREATE MY FIRST PROJECT",
      delete: "DELETE",
      open: "OPEN",
      ai_clips: "AI Clips",
      summary: "Summary",
      exec_summary: "Executive Summary",
      no_analysis: "Automatic analysis not available.",
      key_points: "Key Points",
      prod_assistant: "Production Assistant",
      cut_mode: "CUT MODE",
      smart_timeline: "SMART TIMELINE",
      ui_mode: "UI MODE",
      dynamic_pace: "DYNAMIC PACE",
      plan: "PLAN",
      pro: "PRO",
      free: "FREE (Watermark)",
      upgrade_pro: "UPGRADE TO PRO (29€)",
      buy_credits: "BUY 50 CREDITS (9€)",
      eco_mode: "Economy Mode: AI only activates if your credit balance is sufficient. Upgrade to PRO to remove the video watermark.",
      auto_face: "AUTO-FACE",
      subs: "Subs",
      selected: "SELECTED",
      add: "ADD",
      clips_ready: "Clips ready",
      karaoke_pro: "Pro Karaoke",
      download: "DOWNLOAD",
      rendering: "RENDERING...",
      launch_studio: "LAUNCH STUDIO",
      payment_success: "🎉 Payment successful! Your credits have been added.",
      payment_canceled: "❌ Payment canceled.",
      server_error: "❌ Server error",
      network_error: "❌ Network error",
      secure_connection: "🚀 Secure connection to the studio...",
      confirm_delete: "Permanently delete this project?",
      min: "min",
      sec: "s",
      viral: "VIRAL",
      short: "SHORT",
      story: "STORY",
      standard: "STANDARD",
      clip: "Clip",
      // --- NOUVELLES CLÉS VITRINE ---
      landing_title: "Turn your long videos into viral clips",
      landing_subtitle: "The AI that automatically cuts, subtitles, and reframes your videos. Built for TikTok, Reels, and Shorts.",
      landing_cta_1: "Start for free",
      landing_cta_2: "🎁 15 free credits on signup",
      landing_login: "Login",
      landing_feat_1_title: "Zero-Overlap AI Clipping",
      landing_feat_1_desc: "Our Gemini 2.0 model identifies captivating moments with surgical precision.",
      landing_feat_2_title: "9:16 Auto-Face Tracking",
      landing_feat_2_desc: "The action stays centered thanks to our smart reframing algorithm.",
      landing_feat_3_title: "Pro Karaoke Subtitles",
      landing_feat_3_desc: "Auto-generation and customizable styling to grab and hold attention.",
      landing_pricing: "Clear Pricing",
      landing_pricing_free: "Discovery",
      landing_pricing_free_desc: "15 free credits",
      landing_pricing_pro: "PRO Plan",
      landing_pricing_pro_desc: "29€ / month",
      landing_pricing_pack: "Credits Pack",
      landing_pricing_pack_desc: "9€ / 50 credits",
      back_home: "← Back to Home"
    }
  },
  fr: {
    translation: {
      studio: "Studio",
      dashboard: "Tableau de bord de production",
      credits: "Crédits",
      logout: "Déconnexion",
      new_project: "NOUVEAU PROJET",
      back: "RETOUR",
      new_production: "Nouvelle Production IA",
      pricing: "Tarif de traitement : ",
      one_credit_per_min: "1 Crédit par minute",
      of_video: "de vidéo.",
      click_to_select: "Cliquez pour sélectionner une vidéo",
      formats: "Format MP4, MOV, etc.",
      start_analysis: "LANCER L'ANALYSE IA",
      choose_another: "Choisir un autre fichier",
      processing_warning: "Notre moteur IA traite votre vidéo. Ne fermez pas cette page.",
      retry: "Réessayer",
      syncing: "Synchronisation de vos projets...",
      empty_space: "Votre espace est vide",
      ready_to_transform: "Prêt à transformez vos vidéos longues en clips viraux ? Vous avez",
      credits_to_start: "crédits pour commencer !",
      create_first: "CRÉER MON PREMIER PROJET",
      delete: "SUPPRIMER",
      open: "OUVRIR",
      ai_clips: "Clips IA",
      summary: "Synthèse",
      exec_summary: "Résumé Exécutif",
      no_analysis: "Analyse automatique non disponible.",
      key_points: "Points Clés",
      prod_assistant: "Assistant Production",
      cut_mode: "CUT MODE",
      smart_timeline: "SMART TIMELINE",
      ui_mode: "UI MODE",
      dynamic_pace: "DYNAMIC PACE",
      plan: "PLAN",
      pro: "PRO",
      free: "GRATUIT (Watermark)",
      upgrade_pro: "PASSER PRO (29€)",
      buy_credits: "ACHETER 50 CRÉDITS (9€)",
      eco_mode: "Mode Économie : L'IA ne s'active que si votre solde de crédits est suffisant. Passez à l'abonnement PRO pour supprimer le filigrane vidéo.",
      auto_face: "AUTO-FACE",
      subs: "Subs",
      selected: "SÉLECTIONNÉ",
      add: "AJOUTER",
      clips_ready: "Clips prêts",
      karaoke_pro: "Karaoké Pro",
      download: "TÉLÉCHARGER",
      rendering: "RENDU...",
      launch_studio: "LANCER LE STUDIO",
      payment_success: "🎉 Paiement réussi ! Vos crédits ont été ajoutés.",
      payment_canceled: "❌ Paiement annulé.",
      server_error: "❌ Erreur serveur",
      network_error: "❌ Erreur de réseau",
      secure_connection: "🚀 Connexion sécurisée au studio...",
      confirm_delete: "Supprimer définitivement ce projet ?",
      min: "min",
      sec: "s",
      viral: "VIRAL",
      short: "SHORT",
      story: "STORY",
      standard: "STANDARD",
      clip: "Clip",
      // --- NOUVELLES CLÉS VITRINE ---
      landing_title: "Transformez vos vidéos longues en extraits viraux",
      landing_subtitle: "L'IA qui découpe, sous-titre et recadre automatiquement vos vidéos. Spécialement conçu pour TikTok, Reels et Shorts.",
      landing_cta_1: "Commencer gratuitement",
      landing_cta_2: "🎁 15 crédits offerts à l'inscription",
      landing_login: "Se connecter",
      landing_feat_1_title: "Découpage IA Zéro-Chevauchement",
      landing_feat_1_desc: "Notre modèle Gemini 2.0 identifie les moments captivants avec une précision chirurgicale.",
      landing_feat_2_title: "Auto-Face Tracking 9:16",
      landing_feat_2_desc: "L'action reste toujours au centre grâce à notre algorithme de recadrage intelligent.",
      landing_feat_3_title: "Sous-titres Karaoké Pro",
      landing_feat_3_desc: "Génération automatique et styling personnalisable pour capter et retenir l'attention.",
      landing_pricing: "Tarification simple",
      landing_pricing_free: "Découverte",
      landing_pricing_free_desc: "15 crédits offerts",
      landing_pricing_pro: "Plan PRO",
      landing_pricing_pro_desc: "29€ / mois",
      landing_pricing_pack: "Pack Crédits",
      landing_pricing_pack_desc: "9€ / 50 crédits",
      back_home: "← Retour à l'accueil"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // L'anglais est la langue par défaut
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
